export default "__VITE_ASSET__18e193c8__"